module.exports = __webpack_public_path__ + "static/media/0-2.ebdcf401.svg";